import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;
export const productConditionService = { getAll, store, show, update, updateStatus, softDelete };

export function getAll(filter = {}) {
    const params = { page: filter.pageNumber, size: filter.pageSize };
    if (filter.searchArray?.length) params.search_words = filter.searchArray;
    return apiHelper(API_URL).get('/product-conditions', { params });
}
function payload(data) {
    return { name: data.name, is_active: Boolean(data.isActive) };
}
export function store(data) { return apiHelper(API_URL).post('/product-conditions', payload(data)); }
export function show(uuid) { return apiHelper(API_URL).get(`/product-conditions/${uuid}`); }
export function update(data) { return apiHelper(API_URL).put(`/product-conditions/${data.uuid}`, payload(data)); }
export function updateStatus(uuid, isActive) {
    return apiHelper(API_URL).patch(`/product-conditions/status/${uuid}`, { is_active: Boolean(isActive) });
}
export function softDelete(uuid) { return apiHelper(API_URL).patch(`/product-conditions/delete/${uuid}`); }
